import { render, staticRenderFns } from "./UiReportList.vue?vue&type=template&id=5cb51844&scoped=true"
import script from "./UiReportList.vue?vue&type=script&lang=js"
export * from "./UiReportList.vue?vue&type=script&lang=js"
import style0 from "./UiReportList.vue?vue&type=style&index=0&id=5cb51844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb51844",
  null
  
)

export default component.exports